import { AlertDialog as AlertDialogPrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';
import { AlertDialogOverlay } from './AlertDialogOverlay';
import { AlertDialogPortal } from './AlertDialogPortal';

type AlertDialogContentProps = React.ComponentProps<
  typeof AlertDialogPrimitive.Content
> & {
  size?: 'default' | 'sm';
};

export const AlertDialogContent = ({
  className,
  size = 'default',
  ...props
}: AlertDialogContentProps) => (
  <AlertDialogPortal>
    <AlertDialogOverlay className="!tw-bg-black/50" />
    <AlertDialogPrimitive.Content
      data-slot="alert-dialog-content"
      data-size={size}
      className={cn(
        'data-open:tw-animate-in data-closed:tw-animate-out data-closed:tw-fade-out-0 data-open:tw-fade-in-0 data-closed:tw-zoom-out-95 data-open:tw-zoom-in-95 tw-bg-background tw-ring-foreground/10 tw-gap-4 tw-rounded-xl tw-p-4 tw-ring-1 tw-duration-100 data-[size=default]:tw-max-w-xs data-[size=sm]:tw-max-w-xs data-[size=default]:sm:tw-max-w-sm tw-group/alert-dialog-content tw-fixed tw-top-1/2 tw-left-1/2 tw-z-50 tw-grid tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-outline-none',
        className,
      )}
      {...props}
    />
  </AlertDialogPortal>
);
